/**
 * Optioneel klantproject voor ondertitels en Ritmo (EU-verwerking, besluit 1B, 24 okt 2026).
 * Zonder project: standaardverwerking. Met een project van een klant die alleen EU-verwerking
 * toestaat (bv. Schneider): transcriptie en AI-correctie alleen via Azure in de EU. De server
 * beslist; dit veld toont alleen vooraf wat er gaat gebeuren.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Box, TextField } from '@mui/material';
import { BACKEND_URL } from '../utils/apiConfig';
import { authFetch } from '../utils/authHelpers';

export default function EuProjectVeld({ waarde, onChange, size = 'small', compact = false }) {
  const [beleid, setBeleid] = useState(null);
  useEffect(() => {
    const nr = String(waarde || '').trim();
    if (!nr) { setBeleid(null); return undefined; }
    const t = setTimeout(async () => {
      try {
        const r = await authFetch(`${BACKEND_URL}/Api/klantvereisten/ai-beleid?nummer=${encodeURIComponent(nr)}`);
        setBeleid(r.ok ? await r.json() : { fout: true });
      } catch { setBeleid({ fout: true }); }
    }, 400);
    return () => clearTimeout(t);
  }, [waarde]);

  return (
    <Box>
      <TextField size={size} fullWidth label="Klantproject (optioneel)" placeholder="bv. 9874" value={waarde || ''}
        onChange={(e) => onChange(e.target.value.replace(/[^\w-]/g, '').slice(0, 20))}
        helperText={compact ? undefined : 'Verplicht kiezen bij een klant die alleen EU-verwerking toestaat (bv. Schneider). Zonder project: standaardverwerking.'} />
      {beleid && !beleid.fout && beleid.regio === 'eu' && (
        <Alert severity={beleid.euRouteActief ? 'info' : 'warning'} sx={{ mt: 1 }}>
          {beleid.melding || 'EU-klant: dit wordt alleen in de EU verwerkt.'}
        </Alert>
      )}
      {beleid && !beleid.fout && beleid.regio !== 'eu' && !compact && (
        <Alert severity="success" icon={false} sx={{ mt: 1, py: 0 }}>Geen EU-eis voor dit project: standaardverwerking.</Alert>
      )}
      {beleid?.fout && (
        <Alert severity="warning" sx={{ mt: 1 }}>EU-status van dit project niet te controleren. De server kiest bij twijfel voor EU.</Alert>
      )}
    </Box>
  );
}
